import React, {  useState } from "react";
import { Link } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik } from "formik";
import {  Apitoken, Authtoken } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const PaymentsTermAdd = () => {
  const [backendErrors, setBackendErrors] = useState([]);
  const [menu, setMenu] = useState(false);
  

  const {
    values,
  
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
      amount1: "",
      delay1: "",
      amount2: "",
      delay2: "",
    },
    onSubmit: (values, actions) => {
      axios
        .post("/payment-terms/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Term");
          delete backendErrors['error'];
          actions.setSubmitting(false);

          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/payment-terms";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
         console.log(error)
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  // const customFuction = (event) =>{
  //   var index = event.target.selectedIndex;
  //   var optionElement = event.target.childNodes[index];
  //   var key_sybmol =  optionElement.getAttribute('key_sybmol');
  //   console.log(key_sybmol);
  //   setCurrencySymbol(key_sybmol)
   
  // }

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Payment Terms</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/payment-terms">Payment Terms</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Term</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Term Information</h4>
                    <form action="#" onSubmit={handleSubmit}>
                     
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label> Name</label>
                            <input
                              type="text"
                              name="name"
                              value={values.name}
                              className= "form-input form-control"
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                               placeholder="Enter Payment Term Name"
                            />
                           <small>
                              {backendErrors.name && (
                                <span className="form-error mt-1">
                                  {backendErrors.name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> amount1</label>
                           
                                <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount1"
                                  value={values.amount1}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Amount1" aria-label="Amount1" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">%</span>
                                  </div>
                              </div>


                           <small>
                              {backendErrors.amount1 && (
                                <span className="form-error mt-1">
                                  {backendErrors.amount1}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> delay1</label>
                             <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="delay1"
                                  value={values.delay1}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="delay1" aria-label="delay1" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">weeks</span>
                                  </div>
                              </div>
                           <small>
                              {backendErrors.delay1 && (
                                <span className="form-error mt-1">
                                  {backendErrors.delay1}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> amount2</label>
                            <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="amount2"
                                  value={values.amount2}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Amount2" aria-label="Amount2" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">%</span>
                                  </div>
                              </div>
                           <small>
                              {backendErrors.amount2 && (
                                <span className="form-error mt-1">
                                  {backendErrors.amount2}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> delay2</label>
                            
                            <div className="input-group">
                                  <input 
                                   type="text"
                                   onKeyPress={(event) => {
                                     // Allow only numbers (0-9)
                                     if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                   }}
                                  name="delay2"
                                  value={values.delay2}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="delay2" aria-label="delay2" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                      <span className="input-group-text" id="basic-addon2">weeks</span>
                                  </div>
                              </div>
                           <small>
                              {backendErrors.delay2 && (
                                <span className="form-error mt-1">
                                  {backendErrors.delay2}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                       
                      </div>
                     
                     
                      <small>
                        {backendErrors.status  && (
                          <span className="form-error mt-1">
                            {backendErrors.status}
                          </span>
                        )}

                   
                          
                            </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={isSubmitting}
                        >
                          Add Term
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PaymentsTermAdd;
